/**
 * Toolbar text buttons — exact match to Backlog "Create" (compact).
 * Use for Save, Create, Cancel, and all <Button size="sm|md"> actions.
 */
const base =
  'inline-flex items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-semibold transition-colors border disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap shrink-0';

export const actionBtnPrimary = `${base} bg-brand text-white border-transparent hover:bg-brand/90`;

export const actionBtnOutline = `${base} bg-white text-slate-600 border-slate-200 hover:bg-slate-50`;

export const actionBtnDanger = `${base} bg-red-600 text-white border-red-600 hover:bg-red-700`;

export const actionBtnSuccess = `${base} bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700`;

export const actionBtnGhost = `${base} bg-transparent text-slate-600 border-transparent hover:bg-slate-100`;

/** Icon size inside action buttons (matches Create + / chevron). */
export const actionBtnIconClass = 'h-3.5 w-3.5 shrink-0';
